import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Toaster />
      <Header />
      <main className="flex-1 content-container">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}